import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, FactoryProvider } from '@angular/core';
import { NamingConvention } from 'breeze-client';
import { AjaxHttpClientAdapter } from 'breeze-client/adapter-ajax-httpclient';
import { DataServiceWebApiAdapter } from 'breeze-client/adapter-data-service-webapi';
import { ModelLibraryBackingStoreAdapter } from 'breeze-client/adapter-model-library-backing-store';
import { UriBuilderJsonAdapter } from 'breeze-client/adapter-uri-builder-json';

const initBreeze = (http: HttpClient) => () => {
  // Configure Breeze adapters
  ModelLibraryBackingStoreAdapter.register();
  UriBuilderJsonAdapter.register();
  AjaxHttpClientAdapter.register(http);
  DataServiceWebApiAdapter.register();
  NamingConvention.camelCase.setAsDefault();
};

export const breezeLibraryInitProvider: FactoryProvider = {
  provide: APP_INITIALIZER,
  useFactory: initBreeze,
  deps: [HttpClient],
  multi: true
};
